import IntlMessageFormat from 'intl-messageformat';
/*
    labelMaker -
        Given a template, and variables, it will generate the combined string.
        It supports both passing in a list of values, or a map.
        Because there are currently Lingua values that are in these formats,
        this function must support them.

    Paramters:
        Translation - The lingua value, or string.
        'My Linga Value {0}'
        'My branch {1} Linga Value {0}'
        'Hello: {NAME}, welcome to {BRAND}'

    Example Uses:
    labelMaker('My Linga Value {0}', '5') =>  'My Lingua Value 5'
    labelMaker('My branch {1} Linga Value {0}', 'foo', 'bar') => 'My branch foo Linga Value bar'
    labelMaker('Hello: {NAME}, welcome to {BRAND}', {NAME: 'Phil', BRAND: 'HomeAway'}) => 'Hello: Phil, welcome to HomeAway'
*/

export const labelMaker = (translation = '', ...args) => {
    let formattedMessage = '';
    let valueMap = args;
    let i = 0;

    if (Array.isArray(args) && args.length) {
        if (args.length === 1 && typeof args[0] === 'object') {
            valueMap = args[0];
        } else {
            valueMap = {};
            for (i; i < args.length; i++) {
                valueMap[i] = args[i];
            }
        }
    } else {
        return '';
    }

    try {
        let intlMessageFormat = new IntlMessageFormat(translation);
        formattedMessage = intlMessageFormat.format(valueMap);
    } catch (e) {
        return '';
    }
    return formattedMessage;
};

export const get = (obj, path, def) => {
    // eslint-disable-next-line no-shadow
    const stringToPath = (path) => {
        // If the path isn't a string, return it
        if (typeof path !== 'string') return path;

        // Create new array
        const output = [];

        // Split to an array with dot notation
        path.split('.').forEach(function (item) {
            // Split to an array with bracket notation
            item.split(/\[([^}]+)\]/g).forEach(function (key) {
                // Push to the new array
                if (key.length > 0) {
                    output.push(key);
                }
            });
        });

        return output;
    };

    // Get the path as an array
    path = stringToPath(path);

    // Cache the current object
    let current = obj;

    // For each item in the path, dig into the object
    for (let i = 0; i < path.length; i++) {
        // If the item isn't found, return the default (or null)
        if (!current[path[i]]) return def;

        // Otherwise, update the current value
        current = current[path[i]];
    }

    return current;
};

export const getPropertyUrl = (hit, searchUrlBase, isPinnedPropertySERP) => {
    if (!isPinnedPropertySERP) {
        return hit.propertyHref;
    }
    const joinSymbol = searchUrlBase.indexOf('?') < 0 ? '?' : '&';
    return `${searchUrlBase}${joinSymbol}pinnedPropertyListing=${hit.spu}`;
};

export const pipeFunctions = (...functions) => (arg) =>
    functions.reduce(
        (currentArg, currentFunction) => currentFunction(currentArg),
        arg
    );
